import { useDispatch, useSelector } from 'react-redux';
// redux
import { login, logout, getMe } from '../redux/slices/authJwt';

// ----------------------------------------------------------------------

export default function useAuth() {

  // JWT Auth
  const dispatch = useDispatch();
  const { user, isLoading, isAuthenticated } = useSelector(
    (state) => state.authJwt
  );
    return {
      user,
      isLoading,
      isAuthenticated,

      login: ({ email, password }) =>
        dispatch(
          login({
            email,
            password
          })
        ),
        getUser: () => dispatch(getMe()),
      logout: () => dispatch(logout()),
    };
}
